module.exports = __webpack_public_path__ + "img/deodorizer_tower.6cf6579d.svg";